import script from "./ProjectsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsView.vue?vue&type=style&index=0&id=6415bf12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6415bf12"]])

export default __exports__